import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { ValueObject, Result, BadInputError } from '@digibricks/domains';
export var Score = /*#__PURE__*/function (_ValueObject) {
  _inherits(Score, _ValueObject);

  var _super = _createSuper(Score);

  function Score() {
    _classCallCheck(this, Score);

    return _super.apply(this, arguments);
  }

  _createClass(Score, [{
    key: "value",
    get: function get() {
      return this.props;
    }
  }, {
    key: "toJsonObject",
    value: function toJsonObject() {
      return this.value;
    }
  }], [{
    key: "create",
    value: function create(value) {
      var isLessThanMinScore = value < this.minScore;

      if (isLessThanMinScore) {
        return new BadInputError("The score cannot less than ".concat(this.minScore));
      }

      return Result.ok(new Score(value));
    }
  }]);

  return Score;
}(ValueObject);

_defineProperty(Score, "minScore", 0.0);

_defineProperty(Score, "defaultValue", 1);

_defineProperty(Score, "default", Score.create(Score.defaultValue).getValue());